module.exports = __webpack_public_path__ + "europa-100_emerald_number.jpg?5badca1acacfa0be87e3536bd43225f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-100_emerald_number.jpg
// module id = 266
// module chunks = 0